import React from 'react';
import { useTranslation } from 'react-i18next';
import { playSoundEffect } from '../hooks/useSoundEffects';
import { isPlayer1DevUser } from './isPlayer1DevUser';
import './TutorialReplayButton.css';

/**
 * Fixed bottom-left control for account `player1` to replay a screen tutorial
 * without clearing server seen state.
 */
function TutorialReplayButton({ user, onReplay, className = '' }) {
  const { t } = useTranslation();

  if (!isPlayer1DevUser(user) || typeof onReplay !== 'function') {
    return null;
  }

  return (
    <button
      type="button"
      className={`tutorial-replay-button${className ? ` ${className}` : ''}`}
      onClick={() => {
        playSoundEffect('/sounds/click.mp3');
        onReplay();
      }}
    >
      {t('tutorial.replay')}
    </button>
  );
}

export default TutorialReplayButton;
